import Page from "webPage/Page";

Page.register('page-template-careers-inner', () => {
    $(document).bind('gform_post_render', function () {
        if("undefined" !== typeof hcaptcha){
            hcaptcha.render($('.h-captcha')[0]);
        }
    });
});
